import React, { useEffect } from 'react';
import { useSiteSettings } from '@/context/SiteSettingsContext';

export default function PrivacyPolicy() {
  const s = useSiteSettings();
  const email = s.email || 'pkruparthenterprisepvtltd@gmail.com';
  const phone = s.phone || '+91 99251 90747';
  const address = s.address || 'A/7 Nirkunj, Satellite, Ahmedabad, Gujarat 380015, India';
  const companyName = s.company_name || 'PKRUPARTH ENTERPRISE PVT. LTD.';
  const brandName = s.brand_name || 'NKP VENTURES';

  useEffect(() => { document.title = `Privacy Policy | ${brandName}`; }, [brandName]);

  return (
    <div className="bg-white">
      <div className="pt-32 pb-16 bg-[#F7FAFC] border-b border-[#E5E7EB]">
        <div className="max-w-4xl mx-auto px-6">
          <p className="overline-label text-[#0E5A57] mb-3">Legal</p>
          <h1 className="font-serif text-4xl lg:text-5xl font-bold text-[#153E5C]">Privacy Policy</h1>
          <p className="text-[#6B7280] mt-4 font-sans text-sm">Last updated: January 2025</p>
        </div>
      </div>
      <div className="py-16 max-w-4xl mx-auto px-6 lg:px-8 prose-pkepl">
        <h2>1. Introduction</h2>
        <p>{companyName} ("{brandName}", "we", "us", or "our") is committed to protecting the privacy of individuals who interact with our website and services. This Privacy Policy explains how we collect, use, disclose, and safeguard your information.</p>

        <h2>2. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li><strong>Contact information:</strong> Name, email address, phone number, and company name when you submit an inquiry through our website.</li>
          <li><strong>Usage data:</strong> Information about how you use our website, including pages visited and time spent.</li>
          <li><strong>Communications:</strong> Content of messages you send to us through our contact forms or direct email.</li>
        </ul>

        <h2>3. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul>
          <li>Respond to your inquiries and provide our services</li>
          <li>Communicate with you about our services and operational partnership opportunities</li>
          <li>Improve our website and services</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>4. Information Sharing</h2>
        <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except where required by law or necessary to provide our services. All client information is handled under strict confidentiality agreements.</p>

        <h2>5. Data Security</h2>
        <p>We implement appropriate technical and organisational measures to protect your personal information against unauthorised access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>

        <h2>6. Your Rights</h2>
        <p>Depending on your jurisdiction, you may have the right to access, correct, or delete your personal information. To exercise these rights, please contact us at <a href={`mailto:${email}`}>{email}</a>.</p>

        <h2>7. Cookies</h2>
        <p>Our website may use cookies to enhance your browsing experience. You can choose to accept or decline cookies through your browser settings.</p>

        <h2>8. International Data Transfers</h2>
        <p>As a company that serves international clients, your information may be processed in countries other than your own. We ensure appropriate safeguards are in place for any such transfers.</p>

        <h2>9. Changes to This Policy</h2>
        <p>We may update this Privacy Policy periodically. We will notify you of significant changes by posting the updated policy on our website.</p>

        <h2>10. Contact Us</h2>
        <p>If you have questions about this Privacy Policy, please contact us:</p>
        <ul>
          <li>Email: <a href={`mailto:${email}`}>{email}</a></li>
          <li>Phone: {phone}</li>
          <li>Address: {address}</li>
        </ul>
      </div>
    </div>
  );
}
